(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.wxMock = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  _exports.__esModule = true;
  _exports["default"] = void 0;

  /* eslint-disable */
  var readyCallback;
  var errorCallback;
  var DELAY = 1000;

  var __call = function __call(args, mockFail) {
    setTimeout(function () {
      if (mockFail) {
        return args.fail(null);
      }

      args.success(null);
    }, DELAY);
  };

  var _default = {
    ready: function ready(fn) {
      readyCallback = fn;
    },
    error: function error(fn) {
      errorCallback = fn;
    },
    config: function config(options, mockFail) {
      // eslint-disable-next-line
      console.log("config is called");
      setTimeout(function () {
        if (mockFail) {
          errorCallback ? errorCallback() : null;
          return;
        }

        if (!readyCallback) {
          return;
        }

        readyCallback(options);
      });
    },
    checkJsApi: function checkJsApi(args, mockFail) {
      return __call(args, mockFail);
    },
    updateAppMessageShareData: function updateAppMessageShareData(args, mockFail) {
      return __call(args, mockFail || true);
    },
    updateTimelineShareData: function updateTimelineShareData(args, mockFail) {
      return __call(args, mockFail);
    },
    onMenuShareWeibo: function onMenuShareWeibo(args, mockFail) {
      return __call(args, mockFail);
    },
    closeWindow: function closeWindow() {
      // eslint-disable-next-line
      console.log("Window Closed");
    },
    hideMenuItems: function hideMenuItems(args, mockFail) {
      return __call(args, mockFail);
    },
    hideOptionMenu: function hideOptionMenu(args, mockFail) {
      return __call(args, mockFail);
    },
    showOptionMenu: function showOptionMenu(args, mockFail) {
      return __call(args, mockFail);
    },
    showMenuItems: function showMenuItems(args, mockFail) {
      return __call(args, mockFail);
    },
    hideAllNonBaseMenuItem: function hideAllNonBaseMenuItem(args, mockFail) {
      return __call(args, mockFail);
    },
    showAllNonBaseMenuItem: function showAllNonBaseMenuItem(args, mockFail) {
      return __call(args, mockFail);
    }
  };
  _exports["default"] = _default;
});
//# sourceMappingURL=wxMock.js.map